module.exports = __webpack_public_path__ + "img/circle-three-quarters.03378491.svg";